<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('viaspago.viaspago')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <!-- r-dynamic-list Table CARD-->
      <r-dynamic-list
        ref="rlist"
        :primary="['id']"
        :dbAdapter="ViaPago"
        :tableCode="'VIA_PAGO'"
        :tableMode="true"
        :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
        class="card full-height data-table"
        classContent="card-content full-height"
        :controlsWidth="100"
        :searchOnInit="true"
        :funcShowCheck="_ => true"
        :massiveActions="true"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/viaspago/new/">{{$t('viaspago.nuevo')}}</a>
        </template>
        
        <template v-slot:optionsColumn="{ item }">
          <f7-link icon-f7="eye" color="green" :href="`/viaspago/view/${item.id}/`"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/viaspago/edit/${item.id}/`"></f7-link>
          <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
    <f7-popup ref="popupAsociar" class="popup-asociar" swipe-to-close>
        <f7-page>
          <f7-navbar title="Asociar Empresa">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>

          <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
        <f7-card
          class="elevation-3 padding-vertical-half padding-right"
        >
        <r-form
          ref="rformAsociar"
          v-slot="{rform}"
          :itemId="itemSelected"
          :dbAdapter="ViaPago"
          @save="onSaveAsociar"
        >
          <f7-card-content>
            <f7-list class="list-form">
              <ul>
                <f7-row>
                  <f7-col width="100" medium="100">
                    <r-autocomplete
                      :dbAdapter="Empresa"
                      floating-label
                      :label="$t('viaspago.empresaasociada')"
                      :form="rform"
                      name="idEmpresa"
                      idProp="id"
                      labelProp="nombre"
                    ></r-autocomplete>
                  </f7-col>
                </f7-row>
              </ul>
            </f7-list>
          </f7-card-content>
          <f7-button
            fill
            icon-f7="floppy_disk"
            text="Guardar"
            class="display-flex"
            @click="rform.saveItem();"
          ></f7-button>
        </r-form>
        </f7-card>
        <!-- </div> -->
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import ViaPago from "./../../js/db/ViaPago.js";
import Empresa from "./../../js/db/Empresa.js";

export default {
  components: {
    rDynamicList,
    rForm,
    rInput,
    rAutocomplete
  },
  data() {
    return {
      ViaPago,
      Empresa,
      itemSelected: null
    };
  },
  computed: {},
  methods: {
    onSaveAsociar: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      self.$refs.popupAsociar.close();
      self.$refs.rlist.reload();
      self.$refs.rformAsociar.clear();
    }
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
  }
};
</script>